module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_8003.86e9bf25.png";